import { Navigate, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { useAppContext } from '../Context/AppContext';
import { LogoLoader } from './PageTransitionLoader';
import AmbientBackground from './AmbientBackground';

const ProtectedRoute = ({ children }) => {
	const { state } = useAppContext();
	const location = useLocation();

	if (!state.initialized) {
		return (
			<Box
				sx={{
					position: 'relative',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					minHeight: '100vh',
					overflow: 'hidden',
				}}
			>
				<AmbientBackground />
				<Box sx={{ position: 'relative', zIndex: 1 }}>
					<LogoLoader size={100} />
				</Box>
			</Box>
		);
	}

	if (!state.isAuthenticated) {
		return <Navigate to="/login" state={{ from: location }} replace />;
	}

	return children;
};

export default ProtectedRoute;
